class ConsultarRequest {

    postConsultarCreateSimulacion = (datosConsulta) => {
        return {
            "datos" : {
                "tipoDocumento"     : datosConsulta.tipoDocumento,
                "numeroDocumento"   : datosConsulta.numeroDocumento
            }
        }
    }

}

export default ConsultarRequest;